import { useTranslation } from "react-i18next";
import React from 'react';
import { Container, Row, Col } from 'reactstrap';
import { Helmet } from 'react-helmet-async';
import Layout from 'Components/Layout';
import HideCookieConsent from 'Components/General/HideCookieconsent';
export default (() => {
  const { t } = useTranslation();
  return <Layout>
      <HideCookieConsent />
      <Helmet>
        <title>{t("Terms and Conditions - HeresMyInfo.com")}</title>
      </Helmet>
      <Container>
        <Row>
          <Col style={{
          color: '#212529'
        }}>
            <h1>{t("Terms and Conditions")}</h1>
            <p>{t("Welcome to HeresMyInfo.com. These Terms and Conditions (\"Terms\") govern your use of the HeresMyInfo website and services (the \"Service\") operated by HeresMyInfo, Inc. (\"HMI\", \"we\", \"us\", or \"our\").")}</p>

            <p>{t("By accessing or using our Service, you agree to be bound by these Terms. If you disagree with any part of these Terms, then you may not access the Service.")}</p>

            <h3>{t("1. Acceptance of Terms")}</h3>
            <p>{t("By creating an account, accessing, or using the Service, you acknowledge that you have read, understood, and agree to be bound by these Terms and our Privacy Policy.")}</p>

            <h3>{t("2. Description of Service")}</h3>
            <p>{t("HeresMyInfo is a contact sharing platform that allows users to create and manage digital business cards and share contact information with others. The Service includes web and mobile applications, QR code generation, and related features.")}</p>

            <h3>{t("3. User Accounts")}</h3>
            <p>{t("To use certain features of the Service, you must register for an account. You agree to:")}</p>
            <ul>
              <li>{t("Provide accurate, current, and complete information during registration")}</li>
              <li>{t("Maintain and promptly update your account information")}</li>
              <li>{t("Maintain the security of your password and identification")}</li>
              <li>{t("Accept all responsibility for activities that occur under your account")}</li>
              <li>{t("Notify us immediately of any unauthorized use of your account")}</li>
            </ul>

            <h3>{t("4. User Content")}</h3>
            <p>{t("You retain ownership of any content you submit, post, or display on or through the Service (\"User Content\"). By submitting User Content, you grant HMI a worldwide, non-exclusive, royalty-free license to use, reproduce, modify, adapt, publish, and distribute such content solely for the purpose of providing and improving the Service.")}</p>

            <p>{t("You are solely responsible for your User Content and represent and warrant that:")}</p>
            <ul>
              <li>{t("You own or have the necessary rights to the User Content")}</li>
              <li>{t("The User Content does not violate any third-party rights")}</li>
              <li>{t("The User Content is not illegal, harmful, or offensive")}</li>
            </ul>

            <h3>{t("5. Prohibited Uses")}</h3>
            <p>{t("You agree not to use the Service to:")}</p>
            <ul>
              <li>{t("Violate any applicable laws or regulations")}</li>
              <li>{t("Infringe upon the rights of others")}</li>
              <li>{t("Transmit any harmful, offensive, or illegal content")}</li>
              <li>{t("Impersonate any person or entity")}</li>
              <li>{t("Interfere with or disrupt the Service or servers")}</li>
              <li>{t("Attempt to gain unauthorized access to any portion of the Service")}</li>
              <li>{t("Use automated systems to access the Service without permission")}</li>
            </ul>

            <h3>{t("6. Subscription and Payment")}</h3>
            <p>{t("Certain features of the Service may require a paid subscription. By subscribing, you agree to pay all fees associated with your subscription plan. Fees are charged in advance on a recurring basis. You may cancel your subscription at any time, but refunds are subject to our refund policy.")}</p>

            <h3>{t("7. Intellectual Property")}</h3>
            <p>{t("The Service and its original content, features, and functionality are owned by HMI and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.")}</p>

            <h3>{t("8. Privacy")}</h3>
            <p>{t("Your use of the Service is also governed by our Privacy Policy. Please review our Privacy Policy to understand our practices regarding the collection and use of your information.")}</p>

            <h3>{t("9. Termination")}</h3>
            <p>{t("We may terminate or suspend your account and access to the Service immediately, without prior notice, for any reason, including breach of these Terms. Upon termination, your right to use the Service will cease immediately.")}</p>

            <h3>{t("10. Disclaimer of Warranties")}</h3>
            <p>{t("The Service is provided \"as is\" and \"as available\" without warranties of any kind, either express or implied. We do not warrant that the Service will be uninterrupted, secure, or error-free.")}</p>

            <h3>{t("11. Limitation of Liability")}</h3>
            <p>{t("To the maximum extent permitted by law, HMI shall not be liable for any indirect, incidental, special, consequential, or punitive damages, or any loss of profits or revenues, whether incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible losses resulting from your use of the Service.")}</p>

            <h3>{t("12. Indemnification")}</h3>
            <p>{t("You agree to indemnify and hold harmless HMI, its officers, directors, employees, and agents from any claims, damages, losses, liabilities, and expenses (including legal fees) arising out of your use of the Service or violation of these Terms.")}</p>

            <h3>{t("13. Changes to Terms")}</h3>
            <p>{t("We reserve the right to modify these Terms at any time. We will notify users of any material changes by posting the new Terms on this page and updating the \"Effective Date\" below. Your continued use of the Service after such changes constitutes acceptance of the new Terms.")}</p>

            <h3>{t("14. Governing Law")}</h3>
            <p>{t("These Terms shall be governed by and construed in accordance with the laws of the State of California, United States, without regard to its conflict of law provisions.")}</p>

            <h3>{t("15. Contact Information")}</h3>
            <p>{t("If you have any questions about these Terms, please contact us at:")}</p>

            <p>{t("HeresMyInfo, Inc.")}<br />{t("30 Martin Lane")}<br />{t("Woodside, California 94062")}<br />
            </p>

            <p>{t("Email Address:")}<br />
              <a href='mailto:admin@heresmyinfo.com' target='_blank' rel='noopener noreferrer'>{t("admin@heresmyinfo.com")}</a>
            </p>

            <p>{t("Telephone number:")}<br />
              +1650-530-0149
            </p>

            <p>
              <strong>{t("Effective Date:")}</strong>{t("Aug 07, 2019")}<br />
              <strong>{t("Last Updated:")}</strong> {new Date().getFullYear()}
            </p>

            <p>&nbsp;</p>
          </Col>
        </Row>
      </Container>
    </Layout>;
});